import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Welcome from "./pages/Welcome";
import Dashboard from "./pages/Dashboard";
import Pricing from "./pages/Pricing";
import CapitalGain from "./pages/CapitalGain";
import TDSCalculator from "./pages/TDSCalculator";
import AccountSettings from "./pages/account/Settings";

function Layout({ children, showNav = true }: { children: any; showNav?: boolean }) {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      {showNav && <Navbar />}
      <main style={{ flex: 1 }}>{children}</main>
      {showNav && <Footer />}
      <WhatsAppButton />
    </div>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
          <Route path="/pricing" element={<Layout><Pricing /></Layout>} />
          <Route path="/tools/capital-gain" element={<Layout><CapitalGain /></Layout>} />
          <Route path="/tools/tds-calculator" element={<Layout><TDSCalculator /></Layout>} />
          <Route path="/account/settings" element={<Layout><AccountSettings /></Layout>} />
          <Route path="*" element={<Layout><Home /></Layout>} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}
